import { useBrokerDetailsStore, FormField } from '../../../state/brokerDetailsStore';
import { useBrokerFieldFieldChanged } from '../../../hooks/useBrokerFieldChanged';
import { TextBox } from '@apply/components';
import { ShowIf } from '@apply/ui';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

export const CityField = () => {
    const value = useBrokerDetailsStore((s) => s.businessAddress.city);
    const updateBusinessAddress = useBrokerDetailsStore((s) => s.updateBusinessAddress);
    const isBroker = useBrokerDetailsStore((s) => s.isBroker);
    const changed = useBrokerFieldFieldChanged(FormField.BusinessCity);
    return (
        <>
            <TextBox
                id='cCity'
                value={value}
                onChange={(v) => updateBusinessAddress({ city: v })}
                label='City'
                width={'100%'}
                required={isBroker}
            />
            <ShowIf showIf={changed}>
                <FontAwesomeIcon
                    icon={'asterisk'}
                    className='required-icon'
                />
            </ShowIf>
        </>
    );
};
